import React, { useState, useEffect } from 'react';

// import './styles.css';

import billServices from '../../../../../services/academy/academyBillServices';
import compare from '../../../../../functions/compare';

import { Dots } from "react-activity";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaDollarSign } from 'react-icons/fa';

export default function PopupBillPayment(props) {
    const [bill, setBill] = useState({});
    const [installment, setInstallment] = useState("");
    const [date, setDate] = useState("");
    const [payValue, setPayValue] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [fetching, setFetching] = useState(false);
    let auxDate = new Date();

    useEffect(() => {
        if (installment) {
            const temp = bill.parcelas.find(obj => obj.data_venc.split('-').reverse().join('/') === installment.replace(" (ATRASADA)", ""));
            setPayValue(temp.valor);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [installment]);

    useEffect(() => {
        if (props.data) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            auxDate = new Date();
            auxDate.setHours(auxDate.getHours() - (auxDate.getTimezoneOffset() / 60));
            setDate(auxDate.toISOString().slice(0, 10));
            setBill(props.data);
        }
    }, [props.data]);

    async function registerPayment() {
        if (!bill.paga) {
            if (date && payValue && installment && paymentMethod) {
                setFetching(true);
                const response = await billServices.postBillPayment(
                    bill.id,
                    bill.parcelas.find(obj => obj.data_venc.split('-').reverse().join('/') === installment.replace(" (ATRASADA)", "")).id,
                    date,
                    Number(payValue),
                    billServices.paymentMethods.find(obj => obj[1] === paymentMethod)[0],
                );
                setFetching(false);
                if (response.status === 200) {
                    if (props.onRegisterPayment) props.onRegisterPayment(response.data);
                    cleanStates();
                    props.setVisibility(false);
                } else
                    alert("Erro ao registrar pagamento de conta, tente novamente!");
            } else
                alert("Preencha os dados obrigatórios");
        } else
            alert("A conta já foi paga!");
    }

    function cleanStates() {
        setInstallment("");
        setDate("");
        setPayValue(0);
        setPaymentMethod("");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaDollarSign />}
            tittle="Registrar pagamento"
        >
            <form>
                <Input
                    label="Parcela*"
                    type='select'
                    noFilterOptions
                    options={bill.parcelas ?
                        bill.parcelas
                            .filter(item => !item.paga)
                            .sort((a, b) => compare(a.data_venc, b.data_venc))
                            .map(obj => obj.data_venc.split('-').reverse().join('/') + (auxDate.toISOString().slice(0, 10) > obj.data_venc ? " (ATRASADA)" : ""))
                        : []
                    }
                    id='popup-bill-payment-installment'
                    onChange={(event) => setInstallment(event.target.value)}
                    value={installment}
                />
                <Input
                    label="Data de pagamento*"
                    type='date'
                    id='popup-bill-payment-date'
                    onChange={(event) => setDate(event.target.value)}
                    value={date}
                />
                <Input
                    label="Valor pago*"
                    type='currency'
                    currency={bill.moeda}
                    id='popup-bill-payment-pay-value'
                    onChange={(event) => setPayValue(event.target.value)}
                    value={payValue}
                />
                <Input
                    label="Forma de Pagamento*"
                    type='select'
                    id='popup-bill-payment-payment-method'
                    noFilterOptions
                    options = {billServices.paymentMethods.map(obj => obj[1])}
                    onChange={(event) => setPaymentMethod(event.target.value)}
                    value={paymentMethod}
                />
                <button
                    type="button"
                    className="green"
                    onClick={() => fetching ? alert("Um envio já está em andamento.") : registerPayment()}
                >
                    {
                        fetching ?
                            <Dots />
                            : "Registrar"
                    }
                </button>
            </form>
        </Popup>
    )
}